<template>
  <div>
    <div
      v-if="!onlyText"
      class="text-center mx-auto"
    >
      <svg class="w-[40px] h-[40px] mx-auto">
        <circle
          class="text-gray-300"
          stroke-width="8"
          stroke="currentColor"
          fill="transparent"
          r="15"
          cx="20"
          cy="20"
        />
        <circle
          :class="{
            'text-green-500': passedInPercent <= 0.75,
            'text-yellow-500': passedInPercent > 0.75 && passedInPercent <= 0.9,
            'text-red-600': passedInPercent > 0.9
          }"
          stroke-width="8"
          :stroke-dasharray="2 * Math.PI * 15 * passedInPercent + ' ' + 2 * Math.PI * 15"
          stroke-linecap="round"
          stroke="currentColor"
          fill="transparent"
          r="15"
          cx="20"
          cy="20"
        />
      </svg>
    </div>
    <div
      v-if="passedSeconds > 0 && !isOver"
      class="text-xs text-center"
    >
      <div v-if="withRemainingLabel">
        {{ $t("lot.remaining_time") }}
      </div>
      <div class="font-bold">
        {{ remainingLabel }}
      </div>
    </div>
  </div>
</template>

<script setup>
//https://www.divami.com/blog/usage-svg-stroke-dasharray
import moment from 'moment';
import { compile, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n'

import { useClockStore } from '@/stores/clock';
const { t } = useI18n()

const props = defineProps({
    start: {
        type: Number,
        required: true
    },
    end: {
        type: Number,
        required: true
    },
    onlyText: {
        type: Boolean,
        required: false,
        default: false
    },
    withRemainingLabel: {
      type: Boolean,
      required: false,
       default: true
    }
})

const clockStore = useClockStore()
const totalSeconds = computed(() => {
  return parseInt(moment(props.end).diff(props.start) / 1000, 10);
});

const passedSeconds = computed(() => {
    const diff = moment(clockStore.clock).diff(props.start);
    return parseInt(diff / 1000, 10);
})

const passedInPercent = computed(() => {
    return passedSeconds.value / totalSeconds.value;
});

const remainingLabelBakup = computed(() => {
    const remainingSeconds = totalSeconds.value - passedSeconds.value;
    const remainingMinutes = remainingSeconds/60;
    const remainingHours = remainingMinutes / 60;
    const remainingDays = remainingHours / 24;
    if (remainingDays > 1) {
        return parseInt(remainingDays, 10) + ' ' + t('common.days');
    }
    if (remainingHours > 1) {
        return parseInt(remainingHours, 10) + ' ' + t('common.hours');
    }
    if (remainingMinutes > 5) {
        return parseInt(remainingMinutes, 10) + ' ' + t('common.minutes');
    }
    return parseInt(remainingSeconds, 10) + ' ' + t('common.seconds');
});

const remainingLabel = computed(() => {
  let diffInSeconds = totalSeconds.value - passedSeconds.value;
  const hours = Math.floor(diffInSeconds / 3600);
  diffInSeconds -= hours * 3600;
  const minutes = Math.floor(diffInSeconds / 60);
  diffInSeconds -= minutes * 60;
  const seconds = diffInSeconds;

  return String(hours).padStart(2, '0') + 'h:' + 
         String(minutes).padStart(2, '0') + 'm:' + 
         String(seconds).padStart(2, '0') + 's';
});

const isOver = computed(() => {
    const diff = moment(clockStore.clock).diff(props.end);
    return diff > 0;
})
</script>